export function normalizeWebsiteUrl(value) {
  if (!value) return '';
  const trimmed = value.trimStart();
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed.replace(/^(https?:\/\/)(?:https?:\/\/)+/i, '$1');
  }
  return `https://${trimmed.replace(/^\/+/, '')}`;
}

export function capitalizeEachWord(value, maxWords = 0) {
  const cleaned = value.replace(/[^\p{L}\s'-]/gu, '');
  const trailingSpace = /\s$/.test(cleaned);
  let tokens = cleaned.trim().split(/\s+/).filter(Boolean);
  if (maxWords > 0) tokens = tokens.slice(0, maxWords);

  if (tokens.length === 0) {
    if (!cleaned) return '';
    return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
  }

  const formatted = tokens
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  const limit = maxWords > 0 ? maxWords : Infinity;
  return trailingSpace && tokens.length < limit ? `${formatted} ` : formatted;
}

export function formatContactPersonName(value) {
  return capitalizeEachWord(value, 3);
}

export function formatFoundingYear(value) {
  const currentYear = new Date().getFullYear();
  if (value === '' || value == null) return '';
  const digits = String(value).replace(/\D/g, '');
  if (!digits) return '';
  let year = parseInt(digits, 10);
  if (Number.isNaN(year)) return '';
  if (year > currentYear) year = currentYear;
  return String(year);
}

export function capitalizeFirstLetter(value) {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function downloadBrowserFile(file) {
  if (!file) return;
  const url = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = url;
  link.download = file.name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
